$(function () {
  // 檔案上傳
  $(document).on('click', '.btn-upload.btn-add', function (e) {
    e.preventDefault();

    var controlForm = $(this).closest('.controls'),
      currentEntry = $(this).parents('.entry:first'),
      newEntry = $(currentEntry.clone()).appendTo(controlForm);

    newEntry.find('input').val('');
    controlForm.find('.entry:not(:last) .btn-upload.btn-add')
      .removeClass('btn-add').addClass('btn-remove')
      .html('<span class="fa fa-trash"></span>');
  }).on('click', '.btn-upload.btn-remove', function (e) {
      e.preventDefault();
      $(this).parents('.entry:first').remove();
  });

  function replacer(match, p1, p2, p3, offset, string) {
    // p1 is nondigits, p2 digits, and p3 non-alphanumerics
    return [p1, parseInt(p2)+1, p3].join('');
  }

  // 新增交辦工作
  $(document).on('click', '.stage-box .btn-stage.btn-add', function (e) {
    e.preventDefault();

    var controlForm = $(this).closest('.routine_job_detail'),
      currentEntry = controlForm.find('.next_job_box .row:hidden:first'),
      newEntry = currentEntry.clone();

      // console.log(currentEntry);

    newEntry.find('.select2.select2-container').remove();
    newEntry.find('select').val('');
    newEntry.find('input').val('');
    newEntry.find('textarea').val('');

    newEntry.find('select.next_emp').val([]);

    newEntry.find('.btn-remove').show();
    newEntry.show();

    var re = /(routine_job\[)(\d+)(\]\[\w+\])/;
    $(newEntry).find('[name^="routine_job"]').each(function(i,v){
      var new_name = $(this).attr('name').replace(re, replacer);
      $(this).attr('name',new_name)
    })

    controlForm.find('.stage-box .next_job_box').append(newEntry);
    controlForm.find('select').each(function(){
      var opt = { width: '100%' }
      if(!isNaN($(this).data('maximum')) && $(this).data('maximum') > 0){
          opt.maximumSelectionLength=$(this).data('maximum');
          opt.language={
              maximumSelected: function(args) {return '最多選擇 ' + args.maximum + ' 位'}
          }
      }

      $(this).select2(opt);
    })

  }).on('click', '.stage-box .btn-stage.btn-remove', function (e) {
      e.preventDefault();
      $(this).parents('.row.align-items-center:first').remove();
  });

});